export const fontSpecs = {
  size: 10,
}
